import React from "react";
import { useParams } from "react-router-dom";
import InnerLayout from "../../../components/layouts/inner-layout";
import GenerateEWayBillByIrn from "../../../components/sales-section/e-way-bills/generate-e-way-bill-by-irn";

const GenerateEWayBillByIrnPage = () => {
  const { id } = useParams();

  return (
    <InnerLayout backBtn={true} title="Generate e-Way Bill">
      <GenerateEWayBillByIrn invoiceId={id} />
    </InnerLayout>
  );
};

export default GenerateEWayBillByIrnPage;
